import {
  Background,
  Controls,
  Position,
  ReactFlow,
  useEdgesState,
  useNodesState,
} from "@xyflow/react";
import "@xyflow/react/dist/base.css";
import { useEffect, useRef } from "react";
import { layoutNodes } from "../../../utils/FlowLayout";

const nodeDefaults = {
  sourcePosition: Position.Right,
  targetPosition: Position.Left,
  style: {
    padding: 10,
    borderRadius: 6,
    backgroundColor: "#f0f0f0",
    border: "1px solid #ddd",
  },
};

const Flow = ({
  nodes: propNodes = [],
  edges: propEdges = [],
  handleNodeClick,
}) => {
  const [nodes, setNodes, onNodesChange] = useNodesState(
    propNodes.map((n) => ({ ...nodeDefaults, ...n }))
  );
  const [edges, setEdges, onEdgesChange] = useEdgesState(propEdges);
  const flowInstance = useRef(null);

  useEffect(() => {
    const layoutedNodes = layoutNodes(propNodes, propEdges);
    setNodes(layoutedNodes.map((n) => ({ ...nodeDefaults, ...n })));
    setEdges(propEdges);
  }, [propNodes, propEdges, setNodes, setEdges]);

  const handleNodesChange = (changes) => {
    onNodesChange(changes);
    setNodes((nds) =>
      nds.map((node) => {
        const change = changes.find((c) => c.id === node.id);
        if (!change) return node;
        return { ...nodeDefaults, ...node };
      })
    );
  };

  // Center nodes whenever they change
  useEffect(() => {
    if (flowInstance.current) {
      flowInstance.current.fitView({ padding: 0.2 });
    }
  }, [nodes]);

  return (
    <div style={{ width: "100%", height: "500px" }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={handleNodesChange}
        onEdgesChange={onEdgesChange}
        fitView
        fitViewOptions={{ padding: 0.2 }}
        minZoom={0.5}
        onInit={(instance) => {
          flowInstance.current = instance;
          instance.fitView({ padding: 0.2 });
        }}
        onNodeClick={(e, node) => handleNodeClick(e, node)}
      >
        <Background />
        <Controls />
      </ReactFlow>
    </div>
  );
};

export default Flow;
